import { requestGet,requestPost ,requestPut, requestPutBody , requestUpload } from '../utils/request'
const baseURL = 'http://192.168.2.52:9683';
// const baseURL = 'http://192.168.2.66:9683';
// const baseURL = 'http://laboratory.lianty.cn';
// const baseURL = 'http://asr.lianty.cn';
// 上传录音
export const ltyAsrUploadCreate = (params) => requestUpload( baseURL + '/lty_asr/upload/create', params );
// put请求oss
export const ltyOssUpload = (ossPath,params) => requestPutBody( ossPath, params );
// 上传完成后,需要调用: 通知云端上传完成了
export const ltyAsruploadAf = (params) => requestGet( baseURL + '/lty_asr/upload/af', params );
// 获取链图云语音列表
export const ltyAsrAsrList = (params) => requestGet( baseURL + '/lty_asr/asr/list', params );
// 选中语音后，获取记录列表
export const ltyAsrAsrResultList = (params) => requestGet( baseURL + '/lty_asr/asr/resultList', params );
// 根据录音ID获取翻译结果列表
export const ltyAsrAsrRecordList = (params) => requestGet( baseURL + '/lty_asr/asr/recordList', params );
// 根据录音任务列表id获取结果模板
export const ltyAsrAsrResult = (params) => requestGet( baseURL + '/lty_asr/asr/result', params );
// 根据任务id 获取录音-任务-的解析结果
export const ltyAsrAsrRecordById = (params) => requestGet( baseURL + '/lty_asr/asr/recordById', params );
// 修改录音任务的患者名称和患者病因
export const ltyAsrAsrUpdateInfo = (params) => requestPost( baseURL + '/lty_asr/asr/updateInfo', params );
// 通过录音id获取翻译结果
export const ltyAsrAsrGetRecordByAsrid = (params) => requestGet( baseURL + '/lty_asr/asr/getRecordByAsrid', params );
// 新增结果前-先创建聊天记录
export const ltyAsrAsrCreateResultInfo = (params) => requestPost( baseURL + '/lty_asr/asr/createResultInfo', params );
// 通过id删除录音表
export const ltyAsrAsrDeleteFromAsrInfoByAsrId = (params) => requestGet( baseURL + '/lty_asr/asr/deleteFromAsrInfoByAsrId', params );
// 通过id删除整理结果
export const ltyAsrAsrDeleteFromAsrResultByResultId = (params) => requestGet( baseURL + '/lty_asr/asr/deleteFromAsrResultByResultId', params );











